import HttpRequest from './core/http_request';

class UploadfileProvider extends HttpRequest {
  getStatus () {
    return this.request('get', '/uploadFile/status');
  }

  uploadImg (data) {
    return this.request('upload', '/uploadFile/uploadImg', data);
  }

  getFile (data) {
    return this.request('get', '/uploadFile/getFile', data);
  }

  uploadImageBase64 (data) {
    return this.request('post', '/uploadFile/uploadImageBase64', data);
  }

  uploadConsent (data) {
    return this.request('post', '/uploadFile/uploadConsent', data);
  }
}

export default UploadfileProvider;
